export function getUrlSet(imageName: string, extension: string) {
  return [
    require(`assets/images/${imageName}.${extension}`),
    require(`assets/images/${imageName}@2x.${extension}`),
    require(`assets/images/${imageName}@3x.${extension}`)
  ];
}



export function getUrlSetFromFilename(filename: string) {
  const segments = filename.split('.');
  const extension = segments.pop() as string;
  return getUrlSet(segments.join('.'), extension);
}



export function getUrl(imageName: string, extension: string) {
  return require(`assets/images/${imageName}.${extension}`);
}



export function getUrlFromFilename(filename: string) {
  const segments = filename.split('.');
  const extension = segments.pop() as string;
  return getUrl(segments.join('.'), extension);
}



export function getFileUrl(fileKey: string) {
  return `${process.env.REACT_APP_API_URL?.replace('/graphql', '')}/file/${fileKey}`;
}
